import { useState, type ReactNode } from 'react';

/**
 * 화면 맨 아래에 늘 깔던 설명 문단을 「ⓘ」 버튼 하나로 접는다(10-27 way 「하단 설명은 잘 안 본다 · 상단 최소화, 아래 내용 중심」).
 * 누르면 그 자리 아래에 떠서 보이고, 다시 누르거나 설명을 누르면 닫힌다 — 표가 차지할 높이를 빼앗지 않는다.
 */
export function CalcNote({ label = 'ⓘ 계산 기준', children }: { label?: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative">
      <button type="button" className="whitespace-nowrap text-xs text-ink-soft underline decoration-dotted"
              aria-expanded={open} onClick={() => setOpen((v) => !v)}>{label}</button>
      {open && (
        <div className="absolute right-0 top-full z-30 mt-1 w-[34rem] max-w-[90vw] space-y-1 rounded-lg border border-line bg-white p-3 text-xs leading-5 text-ink-soft shadow-lg"
             onClick={() => setOpen(false)}>
          {children}
        </div>
      )}
    </span>
  );
}
